<div class="naplo-fejlec">
  <h2>Hibakeresés</h2>
  <span class="n-alcim">Vevő–szállító főkönyv/analitika egyeztetés · {{ aktiv.ev }}</span>
  <div class="spacer"></div>
</div>

<!--  A fülsor a SÖTÉT fejlécen belül olvashatatlan volt (kék szöveg kék alapon): az ion-segment a
      világos háttérhez van tervezve. A modul saját fülsora (.n-fulek) a fejléc ALATT áll, és
      ugyanúgy néz ki, mint a többi képernyőn. -->
<div class="n-fulek">
  <button type="button" [class.aktiv]="nezet === 'vsz'" (click)="nezetValt('vsz')">
    <ion-icon name="people-outline"></ion-icon> V/SZ analitika
  </button>
  <button type="button" [class.aktiv]="nezet === 'hibak'" (click)="nezetValt('hibak')">
    <ion-icon name="alert-circle-outline"></ion-icon> Hibalista
  </button>
</div>

<div *ngIf="!aktiv.ugyfelId" class="ures">
  <ion-icon name="business-outline"></ion-icon>
  Először válassz ügyfelet az <b>Ügyfelek</b> fülön.
</div>

<ng-container *ngIf="aktiv.ugyfelId">
  <!-- ===== V/SZ ANALITIKA: a főkönyv és az analitika egyenlege partnerenként ===== -->
  <ng-container *ngIf="nezet === 'vsz'">
    <div class="eszkozsor">
      <ion-select [(ngModel)]="tipus" (ionChange)="betolt()" interface="popover" label="Típus" style="max-width:190px">
        <ion-select-option value="">Vevő és szállító</ion-select-option>
        <ion-select-option value="vevo">Csak vevő</ion-select-option>
        <ion-select-option value="szallito">Csak szállító</ion-select-option>
      </ion-select>
      <ion-item lines="none" class="kapcsolo">
        <ion-checkbox slot="start" [(ngModel)]="csakElteres"></ion-checkbox>
        <ion-label>Csak az eltérő sorok</ion-label>
      </ion-item>
      <span class="spacer"></span>
      <span class="cimke" [class.zold]="!vsz?.elteresek" [class.piros]="vsz?.elteresek">
        {{ vsz?.elteresek ? vsz.elteresek + ' eltérő sor' : 'a két nyilvántartás egyezik' }}</span>
      <ion-button size="small" fill="outline" [disabled]="fut" (click)="betolt()">
        <ion-icon slot="start" [name]="fut ? 'hourglass-outline' : 'refresh-outline'"></ion-icon>Újraszámolás</ion-button>
    </div>

    <div class="tabla-wrap" *ngIf="sorok.length; else nincsSor">
      <table class="naplo-tabla egyeztet">
        <thead>
          <tr>
            <th>Fők.szám</th><th>Partner</th>
            <th class="num">Forgalom T</th><th class="num">Forgalom K</th>
            <th class="num">Analitika T</th><th class="num">Analitika K</th>
            <th class="num">Pü. rendezetlen</th><th class="num">Eltérés</th>
            <th class="num">Nyitó napló</th><th class="num">Nyitó pénzügyi</th><th class="num">Nyitó eltérés</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let r of sorok" [class.baj]="!rendben(r)">
            <td [title]="r.alszamlak ? 'Könyvelt számlák: ' + r.alszamlak : ''">{{ r.fokonyv }}<span class="al" *ngIf="r.alszamlak && r.alszamlak !== r.fokonyv"> ({{ r.alszamlak }})</span></td>
            <td>{{ r.partner }}</td>
            <td class="num">{{ r.forgalom_t | number:'1.0-0' }}</td>
            <td class="num">{{ r.forgalom_k | number:'1.0-0' }}</td>
            <td class="num">{{ r.egy_t | number:'1.0-0' }}</td>
            <td class="num">{{ r.egy_k | number:'1.0-0' }}</td>
            <td class="num">{{ r.pu_rendezetlen | number:'1.0-0' }}</td>
            <td class="num elteres">{{ r.elteres | number:'1.0-0' }}</td>
            <td class="num">{{ r.nyito_naplo | number:'1.0-0' }}</td>
            <td class="num">{{ r.nyito_penzugyi | number:'1.0-0' }}</td>
            <td class="num elteres">{{ r.nyito_elteres | number:'1.0-0' }}</td>
          </tr>
        </tbody>
        <tfoot *ngIf="vsz?.osszesen">
          <tr>
            <td colspan="2">Összesen</td>
            <td class="num">{{ vsz.osszesen.forgalom_t | number:'1.0-0' }}</td>
            <td class="num">{{ vsz.osszesen.forgalom_k | number:'1.0-0' }}</td>
            <td class="num">{{ vsz.osszesen.egy_t | number:'1.0-0' }}</td>
            <td class="num">{{ vsz.osszesen.egy_k | number:'1.0-0' }}</td>
            <td class="num">{{ vsz.osszesen.pu_rendezetlen | number:'1.0-0' }}</td>
            <td class="num elteres">{{ vsz.osszesen.elteres | number:'1.0-0' }}</td>
            <td class="num">{{ vsz.osszesen.nyito_naplo | number:'1.0-0' }}</td>
            <td class="num">{{ vsz.osszesen.nyito_penzugyi | number:'1.0-0' }}</td>
            <td class="num elteres">{{ vsz.osszesen.nyito_elteres | number:'1.0-0' }}</td>
          </tr>
        </tfoot>
      </table>
    </div>
    <ng-template #nincsSor>
      <div class="ures"><ion-icon name="checkmark-done-outline"></ion-icon>
        {{ csakElteres ? 'Nincs eltérő sor – a főkönyv és az analitika egyezik.' : 'Ebben az évben nincs vevő/szállító forgalom.' }}
      </div>
    </ng-template>
    <p class="halvany magyarazat">
      A <b>Forgalom</b> a főkönyvi vevő/szállító számlák tárgyévi mozgása, az <b>Analitika</b> a pénzügyi
      nyilvántartás (számlák és rendezéseik) ugyanazon partnerre. Ahol a kettő különbözik, ott valamit csak az
      egyik oldalon rögzítettünk – a <b>Hibalista</b> fülön tételesen is látszik, mi az.
    </p>
  </ng-container>

  <!-- ===== HIBALISTA: konkrét tételek, javítással ===== -->
  <ng-container *ngIf="nezet === 'hibak'">
    <div class="eszkozsor">
      <span class="cimke piros" *ngFor="let kv of hibaLista?.csoportok | keyvalue">
        {{ hibaRovid(kv.key) }}: {{ kv.value }}</span>
      <span class="cimke zold" *ngIf="hibaLista && !(hibaLista.hibak || []).length">nem találtam hibát</span>
      <span class="spacer"></span>
      <ion-button size="small" fill="outline" [disabled]="fut" (click)="betolt()">
        <ion-icon slot="start" [name]="fut ? 'hourglass-outline' : 'refresh-outline'"></ion-icon>Újrakeresés</ion-button>
    </div>

    <div class="tabla-wrap" *ngIf="(hibaLista?.hibak || []).length">
      <table class="naplo-tabla">
        <thead><tr><th>Dátum</th><th>Bizonylat</th><th>Partner</th><th class="num">Összeg</th><th class="num">Könyvelt</th><th>Mi a baj</th><th></th></tr></thead>
        <tbody>
          <tr *ngFor="let h of hibaLista.hibak">
            <td>{{ h.datum || '—' }}</td>
            <td>{{ h.bizonylatszam || '—' }}</td>
            <td>{{ h.partner || '—' }}</td>
            <td class="num">{{ h.osszeg | number:'1.0-0' }}</td>
            <td class="num">{{ h.konyvelt != null ? (h.konyvelt | number:'1.0-0') : '—' }}</td>
            <td>{{ hibaCim(h.tipus) }}<span class="halvany" *ngIf="h.elteres"> · eltérés: {{ h.elteres | number:'1.0-0' }} Ft</span></td>
            <td>
              <ion-button size="small" fill="outline" *ngIf="h.javithato" (click)="javit(h)">{{ javitasCim(h.javithato) }}</ion-button>
              <span class="halvany" *ngIf="!h.javithato">kézi döntés</span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="ures" *ngIf="hibaLista && !(hibaLista.hibak || []).length">
      <ion-icon name="checkmark-done-outline"></ion-icon>
      Nem találtam eltérést a könyvelés és a pénzügyi nyilvántartás között.
    </div>
  </ng-container>
</ng-container>
